import { gsap } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(DrawSVGPlugin, ScrambleTextPlugin, SplitText);


/////////////////////////////////////////////////////////////////////////////////////////////////////
//header animation
/////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////
//header animation
/////////////////////////////////////////////////////////////////////////////////////////////////////


const header_texts = document.querySelectorAll('.header-text');

if(header_texts.length != 0) {
    document.querySelector('#logo').style.display = "block";
    header_texts.forEach(header_text => {
        header_text.style.display = "block";
    })

    const header_tl = gsap.timeline({repeat: -1, repeatDelay: 0.5});
    const header_split_1 = new SplitText(header_texts[0]);
    const header_split_2 = new SplitText(header_texts[1]);
    const header_split_3 = new SplitText(header_texts[2]);

    const header_words_1 = header_split_1.words;
    const header_words_2 = header_split_2.words;
    const header_words_3 = header_split_3.words;

    header_tl
        .from(header_words_1, {scale: 2, opacity: 0, duration: 0.25, stagger: 0.25})
        .to(header_texts[0], {y: 200, opacity: 0, duration: 0.5}, "+=2")
        .from(header_words_2, {scale: 2, opacity: 0, duration: 0.25, stagger: 0.25})
        .to(header_texts[1], {y: 200, opacity: 0, duration: 0.5}, "+=2")
        .from('.logo-icon', {duration: 1, drawSVG:"0%", ease: 'none'}, "-=0.2")
        .to('.logo-icon', {duration: 0.5, stroke: "transparent", fill: "#353535", ease: 'none'})
        .from('.logo', {duration: 0.5, fill: "transparent", y: 200, stagger: 0.1}, "-=0.2")
        .to('#logo', {duration: 1, opacity: 0}, "+=2")
        .from(header_words_3, {scale: 2, opacity: 0, duration: 0.25, stagger: 0.25}, "-=0.2")
        .to(header_texts[2], {x: 200, opacity: 0, duration: 0.5}, "+=2")

}
//.to('.logo', {duration: 1, fill: "#000000"})
//.to('.logo', {duration: 1, opacity: 0}, "+=2")

/////////////////////////////////////////////////////////////////////////////////////////////////////
//hamburger icon and mobile-menu
/////////////////////////////////////////////////////////////////////////////////////////////////////

const hamburger_wrap = document.querySelector('#hamburger-wrap');
const mobile_nav = document.querySelector('#mobile-nav');
const mobile_nav_links = document.querySelectorAll('#mobile-nav a');

function toggle_mobile_nav() {
    if (hamburger_wrap.classList.contains("active")) {
        mobile_nav.style.top = "calc(var(--nav-height) - 402px)";
        hamburger_wrap.classList.remove("active");
    }
    else {
        mobile_nav.style.top = "var(--nav-height)";
        hamburger_wrap.classList.add("active");
    }
}

mobile_nav_links.forEach(element => element.addEventListener("click", toggle_mobile_nav));
hamburger_wrap.addEventListener("click", toggle_mobile_nav);

/////////////////////////////////////////////////////////////////////////////////////////////////////
//graphbar animation
/////////////////////////////////////////////////////////////////////////////////////////////////////

const graphbars = document.querySelectorAll(".graph-bar");

if(graphbars.length != 0){
    const graphbar_tl = gsap.timeline();
    const numbers = document.querySelectorAll(".number");
    const texts = document.querySelectorAll(".text");



    graphbar_tl
        .from(graphbars, {duration: 1, drawSVG:"0%", ease: 'none', stagger: 0.25})
        .from(numbers, {duration: 1, opacity: 0, ease: "none", stagger: 0.25}, "-=0.75")
        .from(texts, {duration: 1, opacity: 0, ease: "none", stagger: 0.25}, "-=1.65")

}


/////////////////////////////////////////////////////////////////////////////////////////////////////
//checklist
/////////////////////////////////////////////////////////////////////////////////////////////////////

const check_icons = document.querySelectorAll('.check-icon');

function toggle_icon() {
    this.firstElementChild.classList.toggle('hidden');
}

check_icons.forEach(icon => {
    icon.addEventListener('click', toggle_icon);
});

/////////////////////////////////////////////////////////////////////////////////////////////////////
//accordion
/////////////////////////////////////////////////////////////////////////////////////////////////////

const accordion_header = document.querySelectorAll('.accordion-header');

if (accordion_header) {
    accordion_header.forEach(header => {
        header.addEventListener('click', (e) => {
            accordion_header.forEach(item => {
                item.nextElementSibling.style.maxHeight = 0;
                item.firstElementChild.nextElementSibling.style.rotate = '0deg';
            })
            if (e.target.nextElementSibling.style.maxHeight === '0px') {
                e.target.nextElementSibling.style.maxHeight = e.target.nextElementSibling.firstElementChild.offsetHeight + 'px';
                e.target.firstElementChild.nextElementSibling.style.rotate = '-90deg';
            }
            else {
                e.target.nextElementSibling.style.maxHeight = 0;
                e.target.firstElementChild.nextElementSibling.style.rotate = '0deg';
            }
        })
    })
}
